import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CompanyPolicies extends Component {
  static get propTypes() {
    return {
      color: PropTypes.string,
    };
  }

  constructor() {
    super();
    this.state = {
      isSmallScreen: false,
      isSidebarShow: false,
      config: [],
    };
  }

  componentDidMount() {

  }

  render() {
    const{ color } = this.props;

    return (
      <svg xmlns="http://www.w3.org/2000/svg" id="prefix__icon_s_company-policies" width="30" height="30" viewBox="0 0 30 30">
          <g id="prefix__Group_136" data-name="Group 136" transform="translate(4.875 4.875)">
              <path fill={ color } id="prefix__Path_216" d="M234.189 329.532h-4.5a1.087 1.087 0 0 0-1.125 1.041v18.168a1.087 1.087 0 0 0 1.125 1.041h2.5a.75.75 0 0 0 0-1.5h-2.122v-17.25h3.75v1.875h-1.125a.563.563 0 0 0 0 1.125h1.125v1.5h-1.125a.563.563 0 0 0 0 1.125h1.125v1.931a.75.75 0 0 0 1.5 0v-8.015a1.086 1.086 0 0 0-1.128-1.041z" className="prefix__cls-1" data-name="Path 216" transform="translate(-228.564 -329.532)"/>
              <path fill={ color } id="prefix__Path_217" d="M255.012 377.282h-.586a.75.75 0 0 1 0-1.5h.586a.4.4 0 0 0 .427-.375v-1.125a.75.75 0 0 1 1.5 0v1.125a1.9 1.9 0 0 1-1.927 1.875zm-3.606 0h-4.914a1.9 1.9 0 0 1-1.927-1.875v-1.125a.75.75 0 0 1 1.5 0v1.125a.4.4 0 0 0 .427.375h4.914a.75.75 0 1 1 0 1.5z" className="prefix__cls-1" data-name="Path 217" transform="translate(-238.564 -357.032)"/>
              <path fill={ color } id="prefix__Path_218" d="M252.064 342.657h-3.45v-4.834a2.911 2.911 0 0 0 1.192-1.993.728.728 0 0 0 .008-.111 3.006 3.006 0 1 0-6 0v.068a2.665 2.665 0 0 0 .9 1.842v5.028h-3.15a3 3 0 0 0-3 3v2.623a.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75v-2.623a3 3 0 0 0-3-3zm-6.087-5.893c-.479-.45-.614-.595-.663-1.078a1.506 1.506 0 1 1 3-.022c-.092.539-.3.742-.9 1.2a.752.752 0 0 0-.3.6v5.2h-.9v-5.346a.75.75 0 0 0-.237-.554zm7.587 10.768h-13.5v-1.873a1.5 1.5 0 0 1 1.5-1.5h10.5a1.5 1.5 0 0 1 1.5 1.5z" className="prefix__cls-1" data-name="Path 218" transform="translate(-234.814 -331.407)"/>
          </g>
          <path id="prefix__Rectangle_56" d="M0 0H30V30H0z" data-name="Rectangle 56" style={{ fill: 'none' }}/>
      </svg>

    );
  }
}

export default CompanyPolicies;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/components/Layout/components/CompanyPolicies/index.js
 **/